import React, { useState, useEffect } from "react";
import { IProducts, IProductsList } from "../../../products/dto/IProducts";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { PageTemplate } from "../../../../shared/layout/PageTemplate";
import { ProductsService } from "../../../products/service";
import { ErrorToast } from "../../../../shared/toasters/toasters";
import { BaseDataView } from "../../../products/baseData/components/BaseDataView";

export const ViewCrawledBaseData = () => {
  const [currentProduct, setCurrentProduct] = useState<IProducts>();
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    id &&
      ProductsService.getViewProductsById(+id)
        .then((response) => {
          setCurrentProduct(response);
        })
        .catch((error) => ErrorToast(error));
  }, [id]);

  return (
    // <PageTemplate title={`${t("side_bar.crawled_product")}`}>
    <>
      <div className="col-md-12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <div className="d-flex align-itmes-end">
            <ul className="nav nav-pills nav-fill">
              <li className="nav-item">
                <span className="nav-link active">
                  {t("products.base_data_view")}
                </span>
              </li>
              <li>
                <Link
                  className="nav-link"
                  to={`/app/pending-products/crawled/view/attributes/${id}`}
                >
                  {t("products.attributes_view")}
                </Link>
              </li>
              <li>
                <Link
                  className="nav-link"
                  to={`/app/pending-products/crawled/view/content/${id}`}
                >
                  {t("products.content_view")}
                </Link>
              </li>
            </ul>
          </div>
          <>
            <ul className="nav nav-pills">
              <li className="nav-item">
                <a
                  rel="noreferrer"
                  target="_blank"
                  className="nav-link active"
                  href={`${currentProduct?.crawlerUrl}`}
                >
                  {t("crawlers.url")}
                </a>
              </li>
            </ul>
          </>
        </div>
      </div>
      <BaseDataView currentProduct={currentProduct as IProductsList} />
    </>
    // </PageTemplate>
  );
};
